module.exports = __webpack_public_path__ + "static/media/badgeTimeliness.5d8e637b.png";